export default __webpack_public_path__ + "static/media/1.447e2316.JPG";